import { __rest } from "tslib";
import * as React from 'react';
import { DropdownSeparator } from '../Dropdown';
export var ApplicationLauncherSeparator = function ApplicationLauncherSeparator(_a) {
  var children = _a.children,
      props = __rest(_a, ["children"]);

  return React.createElement(DropdownSeparator, Object.assign({}, props));
};